import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.429 10.596c-2.869 3.44-3.06 6.122-1.34 8.38 1.106 1.45 2.894 2.61 4.886 3.456-.26-2.181.396-3.902 1.81-5.831.16-.219.705-.937.668-.889.232-.309.386-.527.505-.723 2.208-3.64 2.423-6.666 1.155-9.225-.713-1.44-1.845-2.644-3.18-3.606.025 2.44-1.534 5.444-4.504 8.438zM11.27.543c2.621 1.51 8.835 6.24 3.543 14.965-1.046 1.711-3.55 3.71-2.713 7.586a.503.503 0 0 1-.656.6C8.474 22.588-.392 18.414 6.66 9.956c3.827-3.863 4.804-7.187 4.012-9.17a.284.284 0 0 1 .402-.354l.195.11zm4.901 17.05c-1.523 1.835-2.088 3.165-2.088 4.312a86.6 86.6 0 0 1 2.23-1.598c2.867-1.993 3.274-4.72 2.186-7.641-.487 1.815-1.355 3.757-2.328 4.927zm-.768-.64c1.409-1.694 2.46-5.023 2.506-6.824v-.097a.195.195 0 0 1 .363-.104c1.214 2.039 3.802 7.59-1.387 11.2-1.49 1.038-2.34 1.67-2.824 2.054l-.072.057a.486.486 0 0 1-.777-.265c-.27-1.114-.328-2.986 2.19-6.021z"
});

var SvgFire = function SvgFire(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgFire;